<template>
  <div class="wt2-dashboard-home wt2-breakpoints" ref="dashboardHome">
    <div class="wt2-dashboard-in-progress" v-show="!showCommonEmptyView">
      <div class="-panel">
        <div class="wt2-text-2xl">
          {{ 'dashboardHome.inProgress' | culture }}
          <a
            href="#"
            class="wt2-text-n -show-all"
            @click.prevent="gotoInProgress"
            >{{ 'dashboardHome.showAll' | culture }}</a
          >
        </div>
        <div class="-control-group">
          <div class="-control">
            <wt-toggle
              :label-left="'dashboardHome.myWork' | culture"
              v-model="$store.state.dashboard.myWork.stories"
              :disabled="isFetchingStories"
              @toggle="refreshStoriesList"
            ></wt-toggle>
          </div>
        </div>
      </div>
      <div class="-content">
        <div v-show="isEmptyStories" class="-empty-state-box">
          <div class="-centered">
            <div class="wt2-text-lm">
              {{ 'dashboardHome.emptyInProgress1' | culture }}
            </div>
            <div v-if="isUserCanCreateStories" class="wt2-text-m">
              {{ 'dashboardHome.emptyInProgress2' | culture }}
            </div>
            <div v-else class="wt2-text-m">
              {{ 'dashboardHome.emptyInProgress3' | culture }}
            </div>
          </div>
        </div>

        <ul
          v-show="!isEmptyStories"
          class="wt2-story-previews list-inline"
          :class="{ '-panel-loading': isFetchingStories }"
        >
          <template v-for="entry in firstStories">
            <story-preview-item
              v-if="entry.story"
              :key="entry.key"
              :story="entry.story"
              tab="Home"
              @itemRemoved="refreshStoriesList"
            />
            <story-preview-group
              v-else
              :key="entry.key"
              :members="entry.members"
              :folder-id="entry.folderId"
              tab="Home"
              @itemRemoved="refreshStoriesList"
            />
          </template>
        </ul>

        <div class="wt-dashboard-loader" v-show="isFetchingStories">
          <div class="wt-loader"></div>
        </div>
      </div>
    </div>
    <div class="wt2-dashboard-storyboards" v-show="!showCommonEmptyView">
      <div class="-panel">
        <div class="wt2-text-2xl">
          <span v-text="storyboardTitle" />
          <a
            href="#"
            class="wt2-text-n -show-all"
            @click.prevent="gotoStoryboards"
            >{{ 'dashboardHome.showAll' | culture }}</a
          >
        </div>
      </div>
      <div class="-content">
        <div v-show="isEmptyStoryboards" class="-empty-state-box">
          <div class="-centered">
            <div class="wt2-text-lm">
              {{ 'dashboardHome.emptyStoryboards' | culture }}
            </div>
          </div>
        </div>

        <ul
          v-show="!isEmptyStoryboards"
          class="wt2-story-previews list-inline -storyboards"
          :class="{ '-panel-loading': isFetchingStoryboards }"
        >
          <li
            is="storyboard-preview-item"
            v-for="(storyboard, i) in firstStoryboards"
            :key="storyboard.id + i"
            :story="storyboard"
            @select="showStoryboardPopup"
            tab="Home"
            @itemRemoved="refreshVideosList"
          ></li>
        </ul>

        <div class="wt-dashboard-loader" v-show="isFetchingStoryboards">
          <div class="wt-loader"></div>
        </div>
      </div>
    </div>

    <div v-if="showCommonEmptyView" class="-common-empty-state-box">
      <div class="-centered">
        <img alt src="/resources/img/empty_first_time_user.png" />
        <div class="-title">{{ 'dashboardHome.emptyBoth1' | culture }}</div>
        <div class="-message">
          <span v-if="isUserCanCreateStories">{{
            'dashboardHome.emptyBoth2' | culture
          }}</span>
          <a href="#" @click.prevent="toggleTeamsWork">{{
            'dashboardHome.emptyBoth3' | culture
          }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import app from 'app';
import StoryPreviewItem from 'v/Dashboard/StoryPreviewItem.vue';
import StoryPreviewGroup from 'v/Dashboard/StoryPreviewGroup.vue';
import StoryboardPreviewItem from 'v/Dashboard/StoryboardPreviewItem.vue';
import StoryboardPopup from 'v/Dashboard/StoryboardPopup.vue';

export default {
  components: {
    StoryPreviewItem,
    StoryPreviewGroup,
    StoryboardPreviewItem,
  },

  created() {
    this.refreshStoriesList({ bReset: false });
    this.refreshVideosList({ bReset: false });
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  mounted() {
    window.addEventListener('resize', this.onResize);

    this.$nextTick(() => {
      this.calcThumbnailCount();
    });
  },

  watch: {
    '$store.state.user.selectedOrganizationId': function () {
      this.refreshStoriesList();
      this.refreshVideosList();
    },
    '$store.state.dashboard.myWork.stories': function (myWorkState) {
      this.$emit('filterschange', {
        filter: 'In Progress: ' + (myWorkState ? 'My Work On' : 'My Work Off'),
      });
    },

    '$store.state.dashboard.myWork.videos': function (myWorkState) {
      this.$emit('filterschange', {
        filter: 'Produced: ' + (myWorkState ? 'My Work On' : 'My Work Off'),
      });
    },
  },

  data() {
    return {
      height: 0,
      itemsInRow: 0,
    };
  },

  computed: Object.assign(
    {
      storyboardTitle() {
        return app.rootStore.getters['user/isTemplateSpecialist']
          ? app.culture.get('storyboards.storyboardCreatorTitle')
          : app.culture.get('storyboards.title');
      },

      isFetchingStories() {
        return this.$store.getters.fetching.homeStories;
      },

      isFetchingStoryboards() {
        return this.$store.getters.fetching.homeStoryboards;
      },

      isEmptyStories() {
        return (
          this.$store.state.dashboard.hasEmpty.homeStories &&
          !this.isFetchingStories
        );
      },

      isEmptyStoryboards() {
        return (
          this.$store.state.dashboard.hasEmpty.homeStoryboards &&
          !this.isFetchingStoryboards
        );
      },

      showCommonEmptyView() {
        return (
          !this.$store.getters.show.familiarWithHomepage &&
          this.$store.state.dashboard.myWork.stories &&
          this.isEmptyStories &&
          this.$store.state.dashboard.myWork.storyboards &&
          this.isEmptyStoryboards
        );
      },

      firstStories() {
        // Grouped entries (one per version family); families render as a
        // StoryPreviewGroup card with a version badge, same as the Drafts tab.
        return this.$store.getters.groupedHomeStories.slice(
          0,
          2 * this.itemsInRow
        );
      },

      firstStoryboards() {
        return this.$store.state.dashboard.homeStoryboards.slice(
          0,
          3 * this.itemsInRow
        );
      },
    },
    app.Vuex.mapGetters(['isUserCanCreateStories'])
  ),

  methods: {
    refreshStoriesList(options) {
      return this.$store.dispatch('fetchHomeStories', options);
    },

    refreshVideosList(options) {
      return this.$store.dispatch('fetchHomeStoryboards', options);
    },

    gotoInProgress() {
      this.$store.commit('resetStoriesFilters');
      app.navigate('dashboard/inProgress');
    },

    gotoStoryboards() {
      app.navigate('dashboard/my-storyboards');
    },

    toggleTeamsWork() {
      this.$store.state.dashboard.show.familiarWithHomepage = true;
      app.stash.set('familiarWithHomepage', true);

      this.$store.state.dashboard.myWork.stories = false;
      this.$store.state.dashboard.myWork.videos = false;
      this.refreshStoriesList();
      this.refreshVideosList();
    },

    calcThumbnailCount() {
      if (!this.$refs.dashboardHome) {
        return;
      }
      const ul = this.$refs.dashboardHome.querySelector('ul');
      this.itemsInRow = getComputedStyle(ul).getPropertyValue(
        '--thumbnails-in-row'
      );
      // console.log(this.itemsInRow);
    },

    onResize: _.debounce(
      function () {
        this.calcThumbnailCount();
      },
      50,
      { leading: true }
    ),

    showStoryboardPopup({ story }) {
      this.mixinShowViewInModal({
        type: 'fullscreen',
        component: StoryboardPopup,
        componentPropsData: {
          video: story,
        },
        showCloseButton: false,
      });
    },
  },
};
</script>
